import {
    PATIENT_INSURANCE_COMPANIES,
    PATIENT_INSURANCE_COMPANY_OTHER,
} from './patient-insurance-companies';

export class PatientInsuranceInfo {
    has_insurance?: boolean;
    company?: string;
    company_other?: string;
    coverage?: string;

    static getDefaultValue(): PatientInsuranceInfo {
        return {
            has_insurance: false,
            company: '',
            company_other: '',
            coverage: '',
        };
    }

    static sanitize(d?: Partial<PatientInsuranceInfo> | null): PatientInsuranceInfo {
        return {
            ...PatientInsuranceInfo.getDefaultValue(),
            ...(d ?? {}),
        };
    }

    static resolveCompanyName(info?: Partial<PatientInsuranceInfo> | null, locale: 'zh' | 'en' = 'zh'): string {
        if (!info?.has_insurance) {
            return '';
        }
        if (info.company === PATIENT_INSURANCE_COMPANY_OTHER) {
            return (info.company_other ?? '').trim();
        }
        const option = PATIENT_INSURANCE_COMPANIES.find((x) => x.value === info.company);
        if (!option) {
            return (info.company_other || info.company || '').trim();
        }
        return locale === 'en' ? option.labelEn : option.labelZh;
    }
}
